import React from 'react';
import request from 'arcdynamic-request';
import {Autocomplete} from "@material-ui/lab";
import {Chip,TextField} from "@material-ui/core";
import { ApolloConsumer } from '@apollo/client';
import { GET_TEAM } from '../Graphql/Queries/propertiesQuery';
import { GET_CONTACT_TEAM_LIST_QUERY } from '../Graphql/ContactsQueries/contactsQuery';
import { fetchData } from '../Service/graphQlService';


export default class SelectTeam extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			items: false,
		};
		this.client = null;
	}

	componentDidMount() {
		// request(arc.path.api, {
		// 	service: 'arcimedes',
		// 	action: 'open.datasource.table.Data.getData',
		// 	params: ['code', 'TEAM', {
		// 		limit: {
		// 			count: 1000,
		// 			offset: 0,
		// 		},
		// 		column: [
		// 			'ARCIMEDES_ROW_ID',
		// 			'FIRST_NAME',
		// 			'LAST_NAME',
		// 			'DELETED',
		// 		],
		// 		filter: [
		// 			{
		// 				code: 'FIRST_NAME',
		// 				text: '',
		// 				type: 'notNull',
		// 			},
		// 			{
		// 				code: 'LAST_NAME',
		// 				text: '',
		// 				type: 'notNull',
		// 			},
		// 		],
		// 		filterType: 'and',
		// 		order: [
		// 			{
		// 				code: 'FIRST_NAME',
		// 				type: 'asc',
		// 			},
		// 			{
		// 				code: 'LAST_NAME',
		// 				type: 'asc',
		// 			},
		// 		],
		// 	}],
		// let token = localStorage.getItem('authToken');
			if(this.client){
				// this.client.query({ query: GET_TEAM, variables: { filters: [], 
				fetchData(GET_CONTACT_TEAM_LIST_QUERY, {type:"Team", filters: [], sortOptions:[{field: "first_name", order: "asc"}, {field: "last_name", order: "asc"}]})
		// 		this.client.query({ query: GET_CONTACT_TEAM_LIST_QUERY, variables: {type:"Team", filters: [], 
		// 							sortOptions:[{field: "first_name", order: "asc"}, {field: "last_name", order: "asc"}]},
		// 			fetchPolicy: "no-cache",
		// 			context: {
		// 			  headers: {
		// 				authorization: `Bearer ${token}`,
		// 			  },
		// 			}

		// })
		.then(res => {
			//let items = res.data ? res.data.filter(x => x.FIRST_NAME && x.LAST_NAME) : false;
			// let items = res.data && res.data.getTeamMembers.teamMember ? res.data.getTeamMembers.teamMember.filter(x => x.first_name && x.last_name) : false;
			let items = res.data && res.data.getContacts.data ? res.data.getContacts.data.filter(x => x.first_name && x.last_name) : false;
			this.setState({items});
		});
	}
	}

	render() {
		const { items } = this.state;
		const inactive = items && items.filter(x => x.deleted === 'y') || [];
		const active = items && items.filter(x => x.deleted !== 'y') || [];
		let itemsSorted = [...active, ...inactive];

		itemsSorted = itemsSorted.map((el) => {
			el.groupedBy = el.deleted !== 'y' ? 'active' : 'inactive';
			return el
		});
		const type = this.props.dropdownType ? this.props.dropdownType : 'single';
		return (
			<ApolloConsumer>
            {
                client => {
                    if (!this.client) {
                        this.client = client;
                    }
                    return (type == "single" ?
			(<Autocomplete
				className={this.props.theme}
				fullWidth	style={{marginBottom: '10px'}} disabled={!items || this.props.disabled}
				getOptionLabel={(option) => {
					let result = '';
					if (option && option.length !== 0) {
						result = option.first_name + ' ' + option.last_name;
					}
					return result;
				}}
				options={itemsSorted}
				groupBy={(option) => option.groupedBy}
				// value={this.props.getValue(this.props.value, items, 'arcimedes_row_id', 'single')}
				value={this.props.getValue(this.props.value, items, 'contact_id', 'single')}
				renderInput={(params) => <TextField {...params} label={this.props.label} variant="outlined" />}
				// onChange={(event, reason) => {this.props.onChange(event, reason, this.props.name, 'single', 'arcimedes_row_id')}}
				 onChange={(event, reason) => {this.props.onChange(event, reason, this.props.name, 'single', 'contact_id')}}
			/>) 	:
			(<Autocomplete
				className={this.props.theme}
				fullWidth style={{ marginBottom: '10px' }} disabled={!items || this.props.disabled}
				getOptionLabel={(option) => {
					let result = '';
					if (option && option.length !== 0) {
						result = option.first_name + ' ' + option.last_name;
					}
					return result;
				}}
				options={itemsSorted}
				groupBy={(option) => option.groupedBy}
				value={this.props.getValue(this.props.value, items, 'arcimedes_row_id', 'multiple')}
				// value={this.props.getValue(this.props.value, items, 'contact_id', 'multiple')}
				renderInput={(params) => <TextField {...params} label={this.props.label} variant="outlined" />}
				onChange={(event, reason) => { this.props.onChange(event, reason, this.props.name, 'multiple', 'arcimedes_row_id') }}
				// onChange={(event, reason) => {this.props.onChange(event, reason, this.props.name, 'multiple', 'contact_id')}}
				renderTags={(tagValue, getTagProps 	) => tagValue.map((option, index) => (
					<Chip key={index} {...getTagProps({ index })} label={option.first_name[0]} />
				))}
				multiple
			/>)
		) 
	
		
	}
	}
	</ApolloConsumer>
		);
	}
}
